import { matchPath, useLocation } from 'react-router'

export function useIsRoute() {
  const { pathname } = useLocation()

  return function (route: string | string[]) {
    const routes = Array.isArray(route) ? route : [route]

    return routes.some((r) => {
      return matchPath(r, pathname)
    })
  }
}
